// import { Image } from "@heroui/image";
// import React from "react";
// import { Icon } from "@iconify/react";

// import { ApplyForJob, FindTalent } from "@/components";
// import { Img32 } from "@/public/assets";

// const HiringRight = () => {
//   return (
//     <section className="max-w-screen-2xl mx-auto lg:px-28 px-6 py-12 grid grid-cols-2 items-center gap-[38px]">
//       <div>
//         <div className="mb-10">
//           <div className="mb-4 text-[32px] font-medium leading-10 tracking-[-0.16px] text-black dark:text-foreground-950 max-w-sm">
//             Hiring is easy but hiring right is the hard part.
//           </div>

//           <div className="text-foreground-700 dark:text-foreground-600 font-normal text-base leading-6 tracking-[-0.176px] mb-6">
//             Businesses struggle after hiring due to misalignment, slow ramp-up,
//             poor performance, and early exits but Cotton Recruiting exists to
//             fix that gap.
//           </div>

//           <div className="flex items-center gap-3 max-w-xs">
//             <FindTalent />
//             <ApplyForJob />
//           </div>
//         </div>

//         <div className="grid grid-cols-2 gap-2">
//           <div className="p-4 bg-[#F8FAFB] dark:bg-foreground-50 rounded-2xl border border-foreground-200 dark:border-foreground-200 inline-flex flex-col">
//             <div>
//               <div className="p-1 border-foreground-200 bg-white dark:bg-foreground-100 rounded-lg border mb-10 inline-flex items-center justify-center">
//                 <Icon
//                   className="text-primary-600 dark:text-primary"
//                   icon="ri:building-fill"
//                 />
//               </div>
//             </div>

//             <div className="text-foreground dark:text-foreground-950 font-medium text-base leading-6 tracking-[-0.176px] mb-3">
//               Business-first screening
//             </div>

//             <div className="text-foreground-700 dark:text-foreground-600 text-sm font-normal leading-5 tracking-[-0.084px]">
//               Selection is done based on how your business actually operates.
//             </div>
//           </div>

//           <div className="p-4 bg-[#F8FAFB] dark:bg-foreground-50 rounded-2xl border border-foreground-200 dark:border-foreground-200 inline-flex flex-col">
//             <div>
//               <div className="p-1 border-foreground-200 bg-white dark:bg-foreground-100 rounded-lg border mb-10 inline-flex items-center justify-center">
//                 <Icon
//                   className="text-primary-600 dark:text-primary"
//                   icon="ri:user-voice-fill"
//                 />
//               </div>
//             </div>

//             <div className="text-foreground dark:text-foreground-950 font-medium text-base leading-6 tracking-[-0.176px] mb-3">
//               Post hire support
//             </div>

//             <div className="text-foreground-700 dark:text-foreground-600 text-sm font-normal leading-5 tracking-[-0.084px]">
//               Our support goes beyond placement in order to ensure successful
//               integration.
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="relative">
//         <Image src={Img32.src} />
//       </div>
//     </section>
//   );
// };

// export default HiringRight;

import { Image } from "@heroui/image";
import React from "react";
import { Icon } from "@iconify/react";

import { ApplyForJob, FindTalent } from "@/components";
import { Img32 } from "@/public/assets";

const HiringRight = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 py-10 sm:py-12 grid grid-cols-1 md:grid-cols-2 items-center gap-8 sm:gap-10 md:gap-[38px]">
      {/* Left Content */}
      <div className="text-center md:text-left">
        <div className="mb-8 sm:mb-10">
          <div
            className="mb-4 text-[24px] sm:text-[28px] md:text-[32px] font-medium leading-8 sm:leading-9 md:leading-10 tracking-[-0.16px] text-black dark:text-foreground-950 max-w-sm mx-auto md:mx-0"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Hiring is easy but hiring right is the hard part.
          </div>

          <div
            className="text-foreground-700 dark:text-foreground-600 font-normal text-sm sm:text-base leading-5 sm:leading-6 tracking-[-0.176px] mb-6"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Businesses struggle after hiring due to misalignment, slow ramp-up,
            poor performance, and early exits but Cotton Recruiting exists to
            fix that gap.
          </div>

          <div
            className="flex flex-col sm:flex-row items-center gap-3 max-w-xs mx-auto md:mx-0"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <FindTalent />
            <ApplyForJob />
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-2">
          <div
            className="p-4 bg-[#F8FAFB] dark:bg-foreground-50 rounded-2xl border border-foreground-200 dark:border-foreground-200 inline-flex flex-col"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div>
              <div className="p-1 border-foreground-200 bg-white dark:bg-foreground-100 rounded-lg border mb-6 sm:mb-10 inline-flex items-center justify-center">
                <Icon
                  className="text-primary-600 dark:text-primary"
                  icon="ri:building-fill"
                />
              </div>
            </div>

            <div className="text-foreground dark:text-foreground-950 font-medium text-base leading-6 tracking-[-0.176px] mb-3">
              Business-first screening
            </div>

            <div className="text-foreground-700 dark:text-foreground-600 text-sm font-normal leading-5 tracking-[-0.084px]">
              Selection is done based on how your business actually operates.
            </div>
          </div>

          <div
            className="p-4 bg-[#F8FAFB] dark:bg-foreground-50 rounded-2xl border border-foreground-200 dark:border-foreground-200 inline-flex flex-col"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div>
              <div className="p-1 border-foreground-200 bg-white dark:bg-foreground-100 rounded-lg border mb-6 sm:mb-10 inline-flex items-center justify-center">
                <Icon
                  className="text-primary-600 dark:text-primary"
                  icon="ri:user-voice-fill"
                />
              </div>
            </div>

            <div className="text-foreground dark:text-foreground-950 font-medium text-base leading-6 tracking-[-0.176px] mb-3">
              Post-hire-support
            </div>

            <div className="text-foreground-700 dark:text-foreground-600 text-sm font-normal leading-5 tracking-[-0.084px]">
              Our support goes beyond placement in order to ensure successful
              integration.
            </div>
          </div>
        </div>
      </div>

      {/* Image */}
      <div
        className="relative w-full"
        data-aos="fade-left"
        data-aos-delay="300"
      >
        <Image
          className="w-full h-auto object-cover rounded-[20px] sm:rounded-[24px] md:rounded-none"
          src={Img32.src}
        />
      </div>
    </section>
  );
};

export default HiringRight;
